import * as z from "../../../vendor/zod/src/index";
export default z.string().min(3).max(6);
